import type { RouteObject } from 'react-router-dom';

import PagePremission from '@/routes/Restrictions/PagePremission';
import { lazyRouteComponent } from '@/utils/lazyLoad';
import AreaTargetPermission from '@/utils/premissions/AreaTargetPermission.enum';

// Lazy load the AreaTarget page
const AreaTargetPage = lazyRouteComponent(
  () => import('@/pages/AreaTarget'),
);

// Lazy load the EmployeePerformance page
const EmployeePerformancePage = lazyRouteComponent(
  () => import('@/pages/EmployeePerformance'),
);

// Define routes for Area Target
const AreaTargetRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <PagePremission prem={AreaTargetPermission.Prem_Area_Target_View}>
        <AreaTargetPage />
      </PagePremission>
    ),
  },
  {
    path: 'performance',
    element: (
      <PagePremission
        prem={AreaTargetPermission.Prem_Area_Target_Manager_View}
        requiredRole={['field_supervisor', 'field_representative']}
      >
        <EmployeePerformancePage />
      </PagePremission>
    ),
  },
];

// Preloading API for performance optimization
export const prefetchAreaTargetRoutes = {
  prefetchAreaTarget: () => void import('@/pages/AreaTarget'),
  prefetchEmployeePerformance: () => void import('@/pages/EmployeePerformance'),
};

export default AreaTargetRoutes;
